import Stack from '@mui/material/Stack';
import Drawer from '@mui/material/Drawer';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useBoolean } from 'src/hooks/use-boolean';
import { useResponsive } from 'src/hooks/use-responsive';
import Iconify from 'src/components/iconify';
import GoalsEditor from './goals-editor';

// ----------------------------------------------------------------------

export default function ScenariosPopover({ onClick }) {
  const drawer = useBoolean();

  return (
    <>
      <Button
        onClick={drawer.onTrue}
        sx={{
          px: 1,
          py: 0.75,
          minWidth: 'auto', // Prevent button from having a minimum width
          display: 'inline-flex', // Ensure button only takes needed space
        }}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <Iconify icon="octicon:goal-24" width={24} color="text.secondary" />
          <Typography variant="caption" color="text.secondary" fontWeight="medium">
            Goals
          </Typography>
        </Stack>
      </Button>
      <GoalDrawer drawer={drawer} />
    </>
  );
}

export function GoalDrawer({ drawer }) {
  const smUp = useResponsive('up', 'sm');

  const renderHead = (
    <Stack
      direction="row"
      alignItems="center"
      sx={{ py: 2, pl: 2.5, pr: 1, minHeight: 68 }}
      spacing={1}
    >
      <Iconify icon="octicon:goal-24" />
      <Typography variant="h6" sx={{ flexGrow: 1 }}>
        Goals
      </Typography>

      {!smUp && (
        <IconButton onClick={drawer.onFalse}>
          <Iconify icon="mingcute:close-line" />
        </IconButton>
      )}
    </Stack>
  );

  return (
    <Drawer
      sx={{ zIndex: 9999 }}
      open={drawer.value}
      onClose={drawer.onFalse}
      anchor="right"
      slotProps={{
        backdrop: { invisible: true },
      }}
      PaperProps={{
        sx: { width: 1, maxWidth: 420 },
      }}
    >
      {renderHead}

      <Divider />

      <GoalsEditor onCancel={drawer.onFalse} />
    </Drawer>
  );
}
